import { useCallback } from 'react';
import { useGetVideoCreditsQuery } from '../../../../redux/api/fymAPI';
import { VideoCredits } from '../../../../redux/api/fymAPI.types';

interface UseVideoCreditsProps {
  /** Null or undefined while no artist is active: the hook reads nothing. */
  accountId: number | null | undefined;
}

export interface VideoCreditsState {
  credits: VideoCredits | null;
  isLoading: boolean;
  error: unknown;
  refetch: () => void;
}

/**
 * The workspace's video credits this month (design g7): the plan count, the pack credits and the
 * sums. Every member reads them; `credits.isOwner` says who may buy a pack. A kit or reel call
 * refreshes them (tag `VideoCredits`).
 */
export function useVideoCredits({ accountId }: UseVideoCreditsProps): VideoCreditsState {
  const skip = accountId === null || accountId === undefined;
  const { data, isLoading, error, refetch } = useGetVideoCreditsQuery({ accountId: accountId ?? 0 }, { skip });
  const retry = useCallback(() => {
    if (skip) {
      return;
    }
    refetch().catch(console.error);
  }, [skip, refetch]);
  return { credits: data ?? null, isLoading, error, refetch: retry };
}
